<template>
  <Modal
    :id="'cmp-catalog-projects-sidewindow-releases-add_release'"
    @cancelled="onCancel"
  >
    <template slot="header">{{
      $dft.snakeCaseToWords($t('add')+" " + $t('release'))
    }}</template>

    <template slot="body">
      <div class="body-container">
        {{$t('search_list')}}
        <!-- <SearchList
          :id="'accounts'"
          :items="accounts || []"
          :keyProperty="'account_id'"
          :label="'account_name'"
          :isSearchable="false"
          @selected="onAccountSelected"
        /> -->
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">
        {{ $t('add')+" " + $t('release') }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import SearchList from "@dtplugins/search-list/search-list";
import { LabelsService } from "../../services/labels.service";
import { Subject } from "rxjs";

export default {
  components: {
    Modal,
    SearchList
  },
  data() {
    return {
      accounts: [],
      selectedAccounts: new Set()
    };
  },
  //   mounted: async function() {
  //     const res = await LabelsService.fetchLabelAccount(
  //       this.label_id
  //     );
  //     console.log("Accounts res ", res.data.accounts);
  //     this.accounts = res.data.accounts;
  //   },
  computed: {
    project_id: function() {
      return this.$route.params.project_id;
    }
  },
  methods: {
    // onArtistsSelected: function(selectedArtists) {
    //   this.selectedArtists = selectedArtists;
    // },
    // onAccountSelected: async function(selectedAccounts) {
    //   console.log(
    //     "selectedAccounts ",
    //     selectedAccounts,
    //     typeof selectedAccounts
    //   ); // Object
    //   this.selectedAccounts = selectedAccounts;
    // },

    onOkClick: async function() {
      // 1. What is the Datatype and Format of account_ids ?
      // 2. You 3 Data label_id, accounts, selectedAccounts. How to make account_ids from these data
      // 3. Then call the service
      // 4. Emit

      //   const account_ids = Array.from(
      //     this.selectedAccounts
      //   ).join(",");
      // Convert to Array,  Join -- convert to string
      // console.log("account_ids ", account_ids);

      //   const res = await LabelsService.labelAddAccount({
      //     account_ids,
      //     label_id: this.label_id
      //   });

      //   const allLabelAccounts = await LabelsService.fetchLabelAccountTable(
      //     this.label_id
      //   );
      //   this.$emit("added", allLabelAccounts.data);
      this.$emit("added", true);
    },

    onCancel: function() {
      this.$emit("cancelled", true);
    }
  }
};
</script>

<style></style>
